/* eslint-disable */
import Checkbox from 'components/form-elements/checkbox/Checkbox'
import Radio from 'components/form-elements/radio/Radio'
import React, { useEffect, useState } from 'react'
import {MdEdit} from 'react-icons/md'
import {AiOutlinePlus} from 'react-icons/ai'
import Order from './Order'
import  Drawer  from 'react-modern-drawer';
import PaymentAddBasketDrawer from './PaymentAddBasketDrawer'
import moment from 'moment'
import auth from 'utils/Auth'
import { useRequest } from 'hooks/useRequest'
import { useNavigate } from 'react-router-dom'
import AddBasketDrawerStageOne from 'components/home/drawers/AddBasketDrawerStageOne'
import useTranslate from 'hooks/useTranslate'
import Textarea from 'components/form-elements/textArea/Textarea'
import { dataLayerPush } from 'utils/Datalayer'

export const InfoEdit = ({onClick,title, description, btnText, btnIcon}) => {
    return (
        <div className='payment-left-infoEdit'>
        <div className='payment-left-infoEdit-cont'>
            <div className='payment-left-infoEdit-title'>{title}</div>
            <div className='body-s payment-left-infoEdit-desc'>{description}</div>
        </div>
        {
          btnText && (
           <div onClick={onClick} className='payment-left-infoEdit-btn'>
             <div>{btnText}</div>
             {btnIcon}
           </div>
          )
        }
        
   </div>
    )
}

const PaymentLeft = ({ setPaymentChoice, paymentChoice ,getAllBasketPayment, propLoading}) => {
    const [request, loading] = useRequest();
    const navigate = useNavigate();
    const [infoAddress, setInfoAddress] = useState({addressName:null, profileName:null})
    const [isOpenDrawer, setIsOpenDrawer] = useState(false)
    const [nextDateChoice, setNextDateChoice] = useState(null)
    const [selectedProduct, setSelectedProduct] = useState({id:null,item:null})
    const [productCount, setProductCount] = useState(1)
    const {t} = useTranslate()
    const paymentChange = (e, val) => {
       setPaymentChoice(prev => ({...prev, [e.target.name]:val}))
    }
    const [productStage, setProductStage] = useState(1)
    const dateFunc = (e) => {
      setNextDateChoice(e.target.value)
      setPaymentChoice(prev =>({...prev, "futureDeliveryDate" : moment(e.target.value).format()}))
    }

    const wantContactLess = (e) => {
        setPaymentChoice(prev => ({...prev, [e.target.name]:e.target.checked}))
    }

    useEffect(() => {
      if(auth.getUserChoises()?.addressId){
        request(`/Profile/Addresses/${auth.getUserChoises()?.addressId}`, {
          method: "GET"
       })
       .then((res) => {
          if(res){
            setInfoAddress(prev => ({...prev, addressName:res.data.result}))
          }
       } )
      }    

      request(`/Profile`, {
        method: "GET"
     })
     .then((res) => {
        if(res){
          setInfoAddress(prev => ({...prev, profileName:res?.data?.result?.firstName + " " + res?.data?.result?.lastName}))
        }
     } )
      
    },[])

    const addBasketBtn = () => {
      setIsOpenDrawer(!isOpenDrawer)
    }


  return (
    <div className='payment-left'>
      {
        propLoading || loading ? <>
					<div className='skeleton skeleton-text'/>
					<div className='skeleton skeleton-text'/>
					<div className='skeleton skeleton-text'/>
					<div className='skeleton skeleton-text'/>
        </>
        : <>
        <h1 className='payment-left-addressSubtitle'>{auth.getUserChoises()?.deliveryType == 2 ? t('cometoMyAddress') : t('comeGetIt')}</h1>
        <h2 className='payment-left-addressTitle'>{t('branch')}: {getAllBasketPayment?.restaurant?.name}</h2>
       <div className='payment-left-addressDescription'>{t('branchAddress')}: {getAllBasketPayment?.restaurant?.address +" "+ `(${getAllBasketPayment?.restaurant?.openTime.substr(0,5)} - ${getAllBasketPayment?.restaurant?.closeTime.substr(0,5)})`}</div>  
        {infoAddress?.profileName && <InfoEdit onClick={() => navigate('/hesabim')} title={t('receiverInfo')} description={infoAddress?.profileName} btnText={t('editBtn')} btnIcon={<MdEdit/>}/>}
        {infoAddress?.addressName && <InfoEdit onClick={() => {}} title={t('address')} description={`${infoAddress?.addressName?.street ? infoAddress?.addressName?.street : ''} ${ infoAddress?.addressName?.addressDescription != null ? infoAddress?.addressName?.addressDescription : ''}`}/>}
        {
          auth.getUserChoises()?.deliveryType == 2 &&  <div className='payment-left-choiceComp'>
          <div className='payment-left-choiceComp-title'>{t('deliveryTime')}</div>
          <div>
          <div className='payment-left-choiceComp-container'><Radio value={null} checked={paymentChoice?.futureDeliveryDate == null} onChange={(e) => paymentChange(e,null)} name={"futureDeliveryDate"}/> {t('now30min')} {getAllBasketPayment?.restaurant?.estimatedDeliveryTime && `(${getAllBasketPayment?.restaurant?.estimatedDeliveryTime})`}</div>
          {/* <div className='payment-left-choiceComp-container'><Radio value={"nextDate"} onChange={(e) => paymentChange(e,"nextDate")}  name={"futureDeliveryDate"}/>{t('postDated')} {(nextDateChoice && paymentChoice?.futureDeliveryDate == moment(nextDateChoice).format()) && "- (" + nextDateChoice +")"}</div>
          {paymentChoice?.futureDeliveryDate == "nextDate" && (
             <input className='payment-left-choiceComp-datePickerInput' type="date" value={nextDateChoice} onChange={dateFunc} />
          )} */}
          </div>
        </div>
        }
       

          <div className='payment-left-choiceComp'>
            <div className='payment-left-choiceComp-title'>{t('wantPlasticKnives')}</div>
            <div>
            <div className='payment-left-choiceComp-container'><Radio value={true} checked={paymentChoice.wantService == true} onChange={(e) => paymentChange(e,true)} name={"wantService"}/> {t('yes')}</div>
            <div className='payment-left-choiceComp-container'><Radio value={false} checked={paymentChoice.wantService == false} onChange={(e) => paymentChange(e,false)}  name={"wantService"}/>{t('no')}</div>
            </div>
          </div>
        {
          auth.getUserChoises()?.deliveryType == 2 && <div className='payment-left-choiceComp payment-left-choiceCompCheckbox'>
          <div className='payment-left-choiceComp-title'>{t('deliveryType')}</div>
          <Checkbox name={"wantContactlessDelivery"} checked={paymentChoice?.wantContactlessDelivery} onChange={wantContactLess} textLabel={t('wantContactlessDelivery')}/>
        </div>
        }
        {/* <ChoiceComp setPaymentChoice={setPaymentChoice} paymentChoice={paymentChoice} title={"Teslimat Zamanı"} description1={"Hemen (~30 dakika)"} description2={"İleri tarihli"} value={{val1: null, val2: "nextDate"}} name = {"futureDeliveryDate"} type={"radio"} dateOpen/> */}
        {/* <ChoiceComp setPaymentChoice={setPaymentChoice} paymentChoice={paymentChoice} title={"Plastik bıçak vs istemiyor musunuz?"} description1={"Evet"} description2={"Hayır"} value={{val1: true, val2: false}} name = "wantService" type={"radio"}/> */}
        {/* <ChoiceComp title={"Teslimat Tipi"} type={"checkbox"} value={false} name={"wantContactlessDelivery"}/> */}
        <div className='payment-left-note'>
            <div className='payment-left-note-title'>{t('orderNote')}</div>
            <Textarea maxLength={500} className='body-s' value={paymentChoice?.note} onChange={e => setPaymentChoice(prev => ({...prev, note: e.target.value}))} placeholder='' name="" id="" cols="30" rows="10" />
        </div>
        <div  id='detay' className="payment-left-order">
          <div className="payment-left-order-top">
              <div className="payment-left-order-top-title">{t('yourOrder')}</div>
              <div onClick={addBasketBtn} className='payment-left-order-top-btn'>
               <div >{t('addProduct')}</div>
                <AiOutlinePlus/>
              </div>
          </div>
           <div className='payment-left-order-container'>
            {
                getAllBasketPayment?.items?.map((order, i) => (
                    <Order setSelectedProduct={setSelectedProduct} setProductCount={setProductCount} setIsOpenDrawer={setIsOpenDrawer} setProductStage={setProductStage} key={i} order={order}/>
                ))
            }
           </div>
        </div>
        </>
      }
       

        <Drawer
                open={isOpenDrawer}
                onClose={() => {
                  setIsOpenDrawer(!isOpenDrawer)
                  setSelectedProduct({ id: null, item: null })
                  setProductStage(1)
                }}
                direction='right'
                className={productStage == 1 ? 'paymentAddBasketDrawer' : 'homeAddBasketDrawer'}
            >
                {productStage == 1 && <PaymentAddBasketDrawer isOpenDrawer={isOpenDrawer} setSelectedProduct={setSelectedProduct} setProductCount={setProductCount} setProductStage={setProductStage} setIsOpenDrawer={setIsOpenDrawer}/>}
                {productStage == 2 && <AddBasketDrawerStageOne isInPayment setSingleDrawerProduct={setSelectedProduct} isOpenDrawer={isOpenDrawer} setProductCount={setProductCount} productCount={productCount} productData={selectedProduct} setIsOpenDrawer={setIsOpenDrawer} setProductStage={setProductStage} />}
            </Drawer>
    </div>
  )
}

export default PaymentLeft